export default __webpack_public_path__ + "static/media/upload.3f5d48ee.png";